<template>
    <AboutLuckyComponent v-if="slug === ABOUT_GAME_SLUG.LUCKY" />
    <AboutNapComponent v-if="slug === ABOUT_GAME_SLUG.NAP" />
    <AboutPermComponent v-if="slug === ABOUT_GAME_SLUG.PERM" />
    <AboutBanker1Component v-if="slug === ABOUT_GAME_SLUG.BANKER1" />
    <AboutBanker2Component v-if="slug === ABOUT_GAME_SLUG.BANKER2" />
    <AboutBanker2Component v-if="slug === ABOUT_GAME_SLUG.BANKER2" />
    <AboutInstantComponent v-if="slug === ABOUT_GAME_SLUG.INSTANT" />
</template>
<script>
import AboutLuckyComponent from '@/components/about/detail/lucky.vue';
import AboutNapComponent from '@/components/about/detail/nap.vue';
import AboutPermComponent from '@/components/about/detail/perm.vue';
import AboutBanker1Component from '@/components/about/detail/banker1.vue';
import AboutBanker2Component from '@/components/about/detail/banker2.vue';
import AboutInstantComponent from '@/components/about/detail/instant.vue';
import { ABOUT_GAME_SLUG } from '@/constants/about';

export default {
    components: {
        AboutNapComponent,
        AboutLuckyComponent,
        AboutBanker1Component,
        AboutBanker2Component,
        AboutPermComponent,
        AboutInstantComponent,
    },
    props: {
        slug: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            ABOUT_GAME_SLUG,
        };
    },
};
</script>
